// extracted by mini-css-extract-plugin
export default {"containerAlunosCidade":"alunosCidade_containerAlunosCidade__yhOkx","titulo":"alunosCidade_titulo__inJ2V"};